// import Swiper core, modules, and css

import { logDiskoSignature } from './disko-signature.js'
import { MainNavigation } from './MainNavigation.js'
import { Footer } from './Footer.js'
import { observeBlocks } from './BlocksObserver.js'

import { Expandable } from './Expandable'

import { storeParams } from './madeForYou.js'

import { joinInputs } from "./joinInputs"

document.addEventListener('DOMContentLoaded', (event) => {
    // console.log('hello Yggdrasil Theme!!')
    
    const mainNavigation = document.body.querySelector('.navigation-container') ? new MainNavigation('(max-width: 767px)') : null
    
    observeBlocks()
    
    const $agegateForm = document.querySelector('.age-gate__form-elements')
    if ($agegateForm) joinInputs($agegateForm)
    
    const $footer = document.querySelector('footer[role="contentinfo"]')
    if ($footer) $footer.expandygg = new Footer('(max-width: 767px)')
    
    
    /* init Stories modal */
    const $storyModalContainer = document.getElementById('stories-modal-container')
    new Expandable($storyModalContainer, {
      debug: false,
      on: {
        open: (region, initiator) => {
          region.querySelector('iframe').src = initiator.dataset.storySrc
        },
        close: (region) => {
          region.querySelector('iframe').src = ''
        }
      }
    })
    
    storeParams()
    
    logDiskoSignature()
    
}, {capture: true, passive: true, once: false} || true)

